eshopApp.controller('FullCartController', ['$scope', '$http', '$cookies', '$rootScope', 'quickModal', 'alertMessage', function($scope, $http, $cookies, $rootScope, quickModal, alertMessage){

	// Helpers
	$scope.helper = CustomNameSpace.helpers;

	$rootScope.m_FullCart = true;
	$scope.cart_empty = null;
	$scope.spinner = true;

	$scope.fetch_counter = 0;
	$scope.old_products = null;

	// Get cart
	$scope.fetch = function() {

		$http.get('/a/get_cart').success(function(response) {

			if(response.products !== false) {

				$scope.cart = response;
				$scope.cart_empty = false;

				// Reload page if products change
				if ($scope.old_products !== null && $scope.old_products !== JSON.stringify(response.products)) {
					//location.reload();
				}
				$scope.old_products = JSON.stringify(response.products);

				// If customer data has been set, set self and ShippingMethodSelector to visible
				/*if (response.has_customer && response.has_shippingaddress && response.has_billingaddress) {
					$rootScope.m_FullCart = true;
					if ($scope.fetch_counter < 1) {
						$rootScope.m_ShippingMethodSelector = true;
					}
				}*/

			} else {
				$scope.cart_empty = true;
			}
		}).finally(function(){
			$scope.spinner = false;
			$scope.fetch_counter += 1;
		});

	}

	// Listen for changes to cookie and update cart (fetch data)
	$scope.$watch(function(){ return $cookies.get('cart_updated') }, function(){
		$scope.fetch();
	});

	// Remove from cart
	$scope.removeFromCart = function(product_id) {

		var modalInstance = quickModal.set('confirmation', generic.confirm, 'md');
		modalInstance.result.then(function(response) {
			if(response === 'ok') {
				$http.post('/a/remove_from_cart', {
					product_id : product_id
				}).success(function(response){
					if (response.message === 'deleted') {
						alertMessage.set(response.alert, 'success');
						$scope.fetch();
					} else {
						alertMessage.set(generic.error, 'error');
						location.reload();
					}
				}).error(function(){
					alertMessage.set(generic.error, 'error');
					location.reload();
				});
			}
		});
	}

	$scope.qtyChanged = []; // indicates that the input for a product quantity has been changed
	$scope.updatingRow = []; // indicates that product quantity is being updated

	// Update quantity for product in cart
	$scope.updateQty = function(product_id, qty) {
		$scope.updatingRow[product_id] = true;
		$http.post('/a/update_cart', {
			product_id : product_id,
			qty : qty
		}).success(function(response){
			if (response.message === 'updated') {
				alertMessage.set(response.alert, 'success');
				$scope.fetch();
			} else {
				location.reload();
			}
		}).error(function() {
			location.reload();
		}).finally(function() {
			$scope.qtyChanged[product_id] = false;
			$scope.updatingRow[product_id] = false;
		});
	}

	// Calculate product x quantity and format
	$scope.calcProductRowTotal = function(price, qty) {
		return $scope.helper.formatPrice(price * qty) + currency_symbol; // helpers.js
	}

}]);
